
import {newGestureUid} from './boxChampEvents';

const SEALED = 'This box is sealed.';

const disabled = extra => ({
  boxName: null,
  canSubstitute: false,
  canCombine: false,
  canSplit: false,
  canAddBox: false,
  disabledReason: null,
  combineReason: null,
  splitReason: null,
  ...extra,
});

export function boxOptions({view, boxId} = {}) {
  if (!view || !view.projection) return disabled({});

  const boxes = view.projection.boxes;
  const index = boxes.findIndex(e => e.box.id === boxId);
  if (index === -1) return disabled({canAddBox: true});

  const entry = boxes[index];
  const sealed = Boolean(entry.sealed);
  if (sealed) {
    return disabled({boxName: entry.box.name, canAddBox: true, disabledReason: SEALED});
  }

  const next = boxes[index + 1];
  const canCombine = Boolean(next && !next.sealed);
  const combineReason = next
    ? next.sealed
      ? 'The next box is already sealed.'
      : null
    : 'No next box to combine.';

  const remaining = entry.rows.reduce((sum, r) => sum + Math.max(r.target - r.filled, 0), 0);
  const canSplit = remaining > 0;

  return {
    boxName: entry.box.name,
    canSubstitute: true,
    canCombine,
    canSplit,
    canAddBox: true,
    disabledReason: null,
    combineReason,
    splitReason: canSplit ? null : 'Nothing left in this box to move.',
  };
}

export function planOpEvent(event, {order, boxId, boxTypeId, userName} = {}) {
  return {
    event,
    uid: newGestureUid(),
    id: order && order.order ? order.order.id : null,
    increment_id: order && order.order ? order.order.increment_id : null,
    updated_at: order && order.order ? order.order.updated_at : null,
    time: new Date(),
    on_ex: 'on GPX',
    state: 'scanpack.rfp.default',
    name: userName || '',
    box_id: boxId == null ? null : boxId,
    box_type_id: boxTypeId == null ? null : boxTypeId,
  };
}

const positiveNumber = value => {
  const n = Number(String(value == null ? '' : value).trim());
  return Number.isFinite(n) && n > 0;
};

export function validateAddBox(form = {}, catalog = []) {
  const errors = {};

  if (!String(form.name || '').trim()) errors.name = 'Enter a name for this box.';

  ['length', 'width', 'height'].forEach(key => {
    if (!positiveNumber(form[key])) {
      errors[key] = `Enter a ${key} greater than zero.`;
    }
  });

  if (!positiveNumber(form.maxWeight)) {
    errors.maxWeight = 'Enter a weight capacity greater than zero.';
  }

  const barcode = String(form.barcode || '').trim().toUpperCase();
  if (barcode) {
    const clash = (Array.isArray(catalog) ? catalog : []).find(
      bt => bt && bt.barcode && String(bt.barcode).trim().toUpperCase() === barcode,
    );
    if (clash) {
      errors.barcode = `That barcode is already used by ${clash.name || 'another box'}.`;
    }
  }

  return {valid: Object.keys(errors).length === 0, errors};
}

export function addBoxPayload(form = {}) {
  const barcode = String(form.barcode || '').trim();
  const payload = {
    name: String(form.name || '').trim(),
    length: Number(form.length),
    width: Number(form.width),
    height: Number(form.height),
    dim_unit: form.dimUnit || 'in',
    weight_unit: form.weightUnit || 'lbs',
  };
  if (barcode) payload.barcode = barcode;
  payload.max_weight = Number(form.maxWeight);
  return payload;
}
